import React, { useState, useEffect } from "react";
import "./MainNav.css";
import { Nav, Navbar } from "react-bootstrap";
import { NavLink } from "react-router-dom";
import { GetNotificationUnreadCount } from "../../apis/NotificationAPI";
import eventBus from "../../utils/eventBus";
import { FiHelpCircle } from "react-icons/fi";
import { useDispatch } from "react-redux";
import { logout } from "../../qcr-auth/slices/authSlice";

export default function MainNav() {
  const [notificationCount, setNotificationCount] = useState(0);
  const dispatch = useDispatch();

  async function GetUserNotificationCount() {
    var result = await GetNotificationUnreadCount();
    setNotificationCount(result.data);
  }

  const handleNewNotification = (d) => {
    GetUserNotificationCount();
  };

  useEffect(() => {
    GetUserNotificationCount();
    eventBus.on("notification", handleNewNotification);
    return () => {
      eventBus.remove("notification", handleNewNotification);
    };
  }, []);

  return (
    <>
      <Navbar.Collapse id="basic-navbar-nav">
        <Nav className="ms-auto qcr-nav">
          <ul className="navbar-nav">
            <li>
              <NavLink to="/Customer/Dashboard" className="nav-link">
                Dashboard
              </NavLink>
            </li>
            <li>
              <NavLink to="/Customer/Orders" className="nav-link">
                Orders
              </NavLink>
            </li>
            <li>
              <NavLink to="/Customer/Forms" className="nav-link">
                Forms
              </NavLink>
            </li>
            <li>
              <NavLink to="/Customer/Reports" className="nav-link">
                Reports
              </NavLink>
            </li>
            <li>
              <NavLink to="/Customer/Invoices" className="nav-link">
                Invoices
              </NavLink>
            </li>
            <li>
              <NavLink to="/Customer/Reference" className="nav-link">
                Reference
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/Customer/Notifications"
                className="nav-link position-relative"
              >
                Notifications{" "}
                <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger">
                  {notificationCount > 0 ? notificationCount : ""}
                </span>
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/"
                onClick={(e) => {
                  dispatch(logout());
                }}
                className="nav-link logout-link"
              >
                Logout
              </NavLink>
            </li>
            <li>
              <NavLink
                to="mailto:order@qcsl.com?subject=Support request from Customer Portal"
                className="nav-link logout-link"
              >
                <FiHelpCircle />
              </NavLink>
            </li>
          </ul>
        </Nav>
      </Navbar.Collapse>
    </>
  );
}
